const ALLOWED_IMAGE_TYPES = new Set(['image/jpeg', 'image/png']);
const ALLOWED_IMAGE_EXTENSION = /\.(jpe?g|png)$/i;
const INVALID_IMAGE_MESSAGE = 'Please choose a JPG, JPEG or PNG image.';
const CHOOSE_IMAGE_TEXT = 'Choose image';
const REPLACE_IMAGE_TEXT = 'Replace image';

class ProductImageUpload extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-image-upload-input]');
    this.status = this.querySelector('[data-image-upload-status]');
    this.buttonText = this.querySelector('[data-image-upload-button-text]');

    if (!this.input || !this.status || !this.buttonText) return;

    this.input.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('change', this.handleChange);
  }

  handleChange = () => {
    const file = this.input?.files?.[0];
    const emptyText = this.status?.dataset.emptyText || 'No image selected';

    if (!this.input || !this.status || !this.buttonText) return;

    this.input.setCustomValidity('');
    this.status.classList.remove('product-form-text__error');
    this.buttonText.textContent = CHOOSE_IMAGE_TEXT;

    if (!file) {
      this.status.textContent = emptyText;
      return;
    }

    const hasAllowedExtension = ALLOWED_IMAGE_EXTENSION.test(file.name);
    const hasAllowedMimeType = !file.type || ALLOWED_IMAGE_TYPES.has(file.type);

    if (!hasAllowedExtension || !hasAllowedMimeType) {
      this.input.setCustomValidity(INVALID_IMAGE_MESSAGE);
      this.status.textContent = INVALID_IMAGE_MESSAGE;
      this.status.classList.add('product-form-text__error');
      this.input.reportValidity();
      return;
    }

    this.buttonText.textContent = REPLACE_IMAGE_TEXT;
    this.status.textContent = file.name;
  };
}

if (!customElements.get('product-image-upload')) {
  customElements.define('product-image-upload', ProductImageUpload);
}
